// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 32) return "static/js/ee76d7d7dadb7caf3552.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"3a35234ed851dc1d6efc","139":"d5ebf7467d94ec6c5de2","140":"c7a068325c4a72c0aaf9"}[chunkId] + ".chunk.js";
};